<template>
  <section class="documents">
    <div class="container">
      <v-app>
        <div class="mt-4">
          <div class="text-h3">Manutenção de Banners</div>
          <v-divider class="mt-1 mb-4" />
            <div class="pa-5">
              Rotina de manutenção de Banners por canal:
              <br>
              Inclusão de novo Banner:
              <ul>
                <li>Selecione a imagem que deseja realizar o upload</li>
                <li>Clique em "Incluir Imagem" (É possivel realizar a inclusão de mais de uma imagem por vez)</li>
                <li>Clique em Salvar para realizar o salvamento dos banners inclusos para o canal</li>
              </ul>
              <br>
              Exclusão de Banners:
              <ul>
                <li>Clique sobre o botão com o icone de lixeira</li>
                <li>Confirme a exclusão da imagem</li>
              </ul>
              <br>
              Exclusão de Banners em massa
              <ul>
                <li>Selecione os banners a serem excluidos pelo "checkbox"</li>
                <li>Um botão de exclusão em massa será exibido após a seleção</li>
                <li>Clique no botão "Excluir Banners Selecionados"</li>
                <li>Não é possivel excluir banners que ainda não foram salvos com essa função (Exclusão somente por botão)</li>
              </ul>
            </div>
          <v-divider class="mt-1 mb-4" />

          <div v-for="(channel, index) in salesChannel" :key="index">
            <list-channel :channel="channel" :token="token"/>
          </div>
        </div>
        <!-- Dialogs -->
        <!-- Loading -->
        <v-dialog v-model="loading.active" persistent width="300">
          <v-card color="var(--standardGreen)" dark>
            <v-card-text style="padding: 27px">
              <div v-html="loading.message"></div>
              <v-progress-linear
                style="margin-top: 15px"
                indeterminate
                color="white"
                class="mb-0"
              ></v-progress-linear>
            </v-card-text>
          </v-card>
        </v-dialog>
        <v-dialog v-model="fixed.active" persistent width="400">
          <v-card>
            <v-card-title class="text-h5" style="background: #005a64; color: white;" v-html="fixed.title"></v-card-title>
            <div class="pa-7" v-html="fixed.message"></div>
          </v-card>
        </v-dialog>
      </v-app>
    </div>
  </section>
</template>

<script>
import axios from 'axios';
import ListChannel from './ListChannel.vue';

export default {
  data() {
    return {
      token: null,
      salesChannel: [],
      teste: null,
      loading: {
        active: false,
        message: null
      },
      fixed: {
        active: false,
        title: null,
        message: null
      }
    };
  },
  components: {
    ListChannel
  },

  created() {
    // Recupera o token do usuário logado
    let dados = JSON.parse(localStorage.getItem("login"));
    this.token = dados.token;
    this.loading.message = "Buscando dados! Aguarde...";
    this.loading.active = true;
    axios.get(
      `https://www.leverosintegra.com.br/map/Api/SolarBanners?token=${this.token}`
    ).then(res => {
      if (res && res.status === 200) {
        this.salesChannel = res.data;
      }
      this.loading.active = false;
    }).catch(err => {
      let msg = "";
      if (err && err.response && err.response.status === 401) {
        window.location = '/login';
        return;
      } else {
        msg += "Erro ao buscar Banners: " + err
      }
      this.fixed.title = "Ops...";
      this.fixed.message = msg;
      this.loading.active = false;
      this.fixed.active = true;
    })
  }
};
</script>

<style lang="scss" scoped>
.documents {
  .container {
    max-width: 90%;
    margin: 0 auto;

    .header {
      display: flex;
      margin: 20px 0;

      button {
        background: var(--standardGreen);
        color: var(--white);
        border-radius: 5px;
        padding: 10px;
        width: 40%;
      }

      input {
        border-bottom: 1px solid var(--gray-500);
        outline: none;
        margin-left: 20px;
        color: var(--gray-500);
        width: 100%;
      }
    }

    .loader {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 80px;

      i {
        color: var(--blue);
        font-size: 4rem;
      }
    }

    .table {
      table {
        width: 100%;
        border-collapse: collapse;
        border-spacing: 0;

        thead {
          tr {
            th {
              background: var(--gray-70);
              padding: 5px;
            }
          }
        }

        tbody {
          tr {
            td {
              padding: 10px;
              border-bottom: 1px solid var(--gray-100);
              text-align: center;

              button {
                background: var(--gray-100);
                color: var(--gray-800);
                border-radius: 10px;
                padding: 5px;
                outline: none;
              }

              a {
                color: var(--darkGreen);
              }
            }
          }
        }
      }
    }
  }
}
</style>